import { useHandleBrandContext } from '../../../../../hooks/useHandleBrandContext';
import { useApplicationContext } from '../../../../../modules/context/ApplicationContext/ApplicationContext';
import { useAbility } from '../../../../../modules/users/AbilityContext';
import { UserRole } from '../../../../../modules/users/roles';
import { useAppEnvironmentStore } from '../../../../../stores/AppEnvironment/appEnvironment.store';
import { selectIsInStoreEnvironment } from '../../../../../stores/AppEnvironment/appEnvironment.store.selectors';

const canChangeBrand = (userRole?: UserRole) =>
  userRole === 'ADMIN_LOJA' || userRole === 'COMPRADOR';

const useHomeNavigationHeader = () => {
  const ability = useAbility();
  const { state, userRole } = useApplicationContext();
  const canSelectBrand = canChangeBrand(userRole) && state.options.showBrand;

  const isInStoreEnvironment = useAppEnvironmentStore(selectIsInStoreEnvironment);
  const { isBrandContextValid, brandModal, selectBrand } = useHandleBrandContext();

  const verifyBrandContext = (callback: () => void) => {
    if (isBrandContextValid) {
      callback();
      return;
    }
    brandModal.openModal();
  };

  return {
    canSelectBrand,
    isInStoreEnvironment,
    verifyBrandContext,
    canCreateOrders: ability.can('create', 'orders'),
    brandModal,
    selectBrand,
    brands: state.brands,
  };
};

export default useHomeNavigationHeader;
